let webSocket = null;
let socketOpen = false;
let timeInterval = null;
let lastReceiveMsgTime = null;
let lastHavadataLogTime = null; // 用于记录上次日志的时间
const logKey = 'wss_log'; // Key for localStorage

// Function to log messages to localStorage
const logMessage = (status) => {
    if (window.location.hostname.includes('ios')) {
        const logEntry = {
            at: new Date(),
            status: status
        };
        let logs = JSON.parse(localStorage.getItem(logKey)) || [];
        
        // Add new log entry
        logs.push(logEntry);
        
        // Limit logs to 1000 entries
        if (logs.length > 1000) {
            logs.shift(); // Remove the oldest log entry
        }
        
        localStorage.setItem(logKey, JSON.stringify(logs));
    }
}

// 发送消息
export const doSend = (message) => {
    if (socketOpen) {
        webSocket.send(message);
    }
}

// 初始化websocket
export const contactSocket = (that,msg) => {
    if ("WebSocket" in window) {
        // webSocket = new WebSocket("ws://192.168.5.147:8088/");
        createWebSocket(that,msg);
    }
}
function createWebSocket(that,msg){
    let url ="";
    if(process.env.NODE_ENV == 'development'){
        //本地如果有websocket，那么可以切换
        url = "ws://"+window.location.hostname+":6161"
        // url="wss://ios-webrtc-tmp.demo-app.jp/wss"
    }else{
        url = "wss://"+window.location.hostname+"/wss"
    }
    webSocket = new WebSocket(url);
    webSocket.onopen = function () {
        console.log("连接成功！");
        logMessage('ok'); // Log connection success
        localStorage.setItem('tsunagaru-websocket','online');
        webSocket.send(msg)
        socketOpen = true;
        timeInterval = setInterval(() => {
            if(lastReceiveMsgTime){
                var currentTimeSecond = new Date().getTime();
                var lastReceiveMsgTimeSecond = lastReceiveMsgTime.getTime();
                console.log(Math.floor(Math.abs(currentTimeSecond - lastReceiveMsgTimeSecond) / 1000))
                if(Math.floor(Math.abs(currentTimeSecond - lastReceiveMsgTimeSecond) / 1000) >60){
                    logMessage('reload'); // Log no data received
                    console.log("close websocket")
                    socketOpen = false;
                    clearInterval(timeInterval);
                    if(webSocket && webSocket.readyState !== WebSocket.CLOSED){
                        webSocket.close()
                    }else{
                        reConnect(that,msg)
                    }
                }else{
                    that.connectWebSocket(webSocket);
                }
            }else{
                lastReceiveMsgTime = new Date();
                that.connectWebSocket(webSocket);
            }
        }, 3000);
    };
    webSocket.onmessage = function (evt) {
        lastReceiveMsgTime = new Date(); // 更新接收到消息的时间
        var received_msg = evt.data;
        that.receiveMsg(received_msg);
        
        // 每分钟记录一次数据接收
        const currentTime = new Date();
        if (!lastHavadataLogTime || (currentTime - lastHavadataLogTime) >= 60000) {
            logMessage('havadata'); // 记录数据接收
            lastHavadataLogTime = currentTime; // 更新上次记录时间
        }
        
        // 重置 nodata 日志条件
        clearTimeout(nodataTimeout);
        nodataTimeout = setTimeout(() => {
            logMessage('nodata'); // 如果超时则记录没有数据接收
        }, 20000); // 设置超时为 20 秒
    };
    webSocket.onclose = function () {
        console.log("连接关闭！");
        logMessage('ng'); // Log connection failure
        localStorage.setItem('tsunagaru-websocket','offline');
        socketOpen = false;
        reConnect(that,msg)
    };
    webSocket.onerror = function () {
        console.log("连接异常！");
        logMessage('error'); // Log connection error
        localStorage.setItem('tsunagaru-websocket','offline');
        socketOpen = false;
    };
}
function reConnect(that,msg){
    clearInterval(timeInterval);
    lastReceiveMsgTime = null;
    logMessage('recon'); // Log reconnection attempt
    setTimeout(() => {
        createWebSocket(that,msg);
    }, 500);
}

let nodataTimeout; // Declare a timeout variable for nodata logging
